import { render, staticRenderFns } from "./WorkOrder02List.vue?vue&type=template&id=1536fde4&"
import script from "./WorkOrder02List.vue?vue&type=script&lang=js&"
export * from "./WorkOrder02List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports